module.exports = __webpack_public_path__ + "static/img/avatar_r_13.63d73f4b.png";